export const search = {
  search: "Suche",
  searchTerm: "Suchbegriff"
};
